const JOB_TEMPLATE = Object.freeze({
  METADATA_EXTRACTOR: 1,
  THUMBNAIL_CREATOR: 2,
  MAPPER_API_DISPATCHER: 3,
  FILE_CLASSIFIER: 4,
  BATCH_ML_DISPATCHER: 5,
  GROUND_PROJECTOR: 6,
  ONLINE_ML_DISPATCHER: 7,
  HLS_CONVERTER: 8,
  HTTP_REQUESTER_BATCH: 9,
  HTTP_REQUESTER: 10,
  MAPPER_API_VIDEO_DISPATCHER: 11,
});

export default JOB_TEMPLATE;

export const GENKONE_JOB_TEMPLATE_ID = JOB_TEMPLATE.MAPPER_API_VIDEO_DISPATCHER;
